import eduLibrary from '@/pages/layouts/edu-pages/Library.vue'


export const eduRouter = [{
  path: '/edu/library',
  name: 'eduLibrary',
  component: eduLibrary,
  meta: {
    keepAlive: true // 需要缓存
  }
}]



// WEBPACK FOOTER //
// ./src/router/layout-router/edu-router.js